import { Text } from '@/components/DesignSystem';
import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px="16px"
    >
      <Text category="headline-medium" textAlign="center">
        {t($ => $.customerDashboard.landing.contactSalesperson)}
      </Text>
    </Stack>
  );
};
